/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_VotedInputs */

const en_us2_community_voted = /** @type {(inputs: Community_VotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voted`)
};

const pt_br2_community_voted = /** @type {(inputs: Community_VotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votado`)
};

const es_419_community_voted = /** @type {(inputs: Community_VotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votado`)
};

const pt_pt2_community_voted = /** @type {(inputs: Community_VotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votado`)
};

const fr_fr2_community_voted = /** @type {(inputs: Community_VotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voté`)
};

const de_de2_community_voted = /** @type {(inputs: Community_VotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgestimmt`)
};

const it_it2_community_voted = /** @type {(inputs: Community_VotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votato`)
};

/**
* | output |
* | --- |
* | "Voted" |
*
* @param {Community_VotedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_voted = /** @type {((inputs?: Community_VotedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_VotedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_voted(inputs)
	if (locale === "es-419") return es_419_community_voted(inputs)
	if (locale === "pt-PT") return pt_pt2_community_voted(inputs)
	if (locale === "fr-FR") return fr_fr2_community_voted(inputs)
	if (locale === "de-DE") return de_de2_community_voted(inputs)
	if (locale === "it-IT") return it_it2_community_voted(inputs)
	return en_us2_community_voted(inputs)
});
export { community_voted as "community.voted" }